import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify"; // Assuming you use toast for feedback
import moment from "moment";
import SightSeeingTabs from "../AllTabs/SightSeeingTabs";

const SightSeeingAdminUpdate = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    // List States
    const [pageLoading, setPageLoading] = useState(false);
    const [lists, setLists] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);

    // Edit Modal States
    const [showModal, setShowModal] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [editForm, setEditForm] = useState({
        bookingStatus: "",
        paymentStatus: "",
        supplierBookingStatus: "",
        ticketFile: null,
    });

    const GetData = async (pNum) => {
        setPageLoading(true);
        try {
            const res = await apiService.post(
                `${config.GETSIGHTSEEINGFORADMIN}/${user?.cid}`,
                pageSize,
                pNum
            );
            console.log("Fetched data", res);
            setLists(res);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setPageLoading(false);
        }
    };

    useEffect(() => {
        if (user && !loading) {
            GetData(pageNumber);
        }
    }, [user, loading, pageNumber]);

    // Handle Edit Button Click
    const handleEditClick = (booking) => {
        setSelectedBooking(booking);
        setEditForm({
            bookingStatus: booking.bookingStatus || "PENDING",
            paymentStatus: booking.paymentStatus || "PENDING",
            supplierBookingStatus: booking.supplierBookingStatus || "PENDING",
            ticketFile: null,
        });
        setShowModal(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditForm({ ...editForm, [name]: value });
    };

    const handleFileChange = (e) => {
        setEditForm({ ...editForm, ticketFile: e.target.files[0] });
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        setBtnLoading(true);

        const formData = new FormData();
        formData.append("SightSeeingBookingId", selectedBooking.sightSeeingBookingId);
        formData.append("BookingStatus", editForm.bookingStatus);
        formData.append("PaymentStatus", editForm.paymentStatus);
        formData.append("SupplierBookingStatus", editForm.supplierBookingStatus);

        if (editForm.ticketFile) {
            formData.append("TicketFile", editForm.ticketFile);
        }

        try {
            // Using post because the backend attribute is [HttpPost("UpdateBooking")]
            console.log("Submitting form data", formData);
            const res = await apiService.update(config.UPDATESIGHTSEEINGBYADMIN, formData);
            if (res.succeeded) {
                setShowModal(false);
                GetData(pageNumber); // Refresh list
            } else {
                toast.error(res.message || "Update failed");
            }
        } catch (error) {
            toast.error("An error occurred during update");
        } finally {
            setBtnLoading(false);
        }
    };

    if (loading) return <p>Loading...</p>;
    if (!user) { navigate("/"); return null; }

    return (
        <div id="layout-wrapper">
            <Header User={user} />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="col-xl-12">
                            <div className="card">
                                {/* <div className="p-2">
                  <SightSeeingTabs pageName="SIGHTSEEINGBOOKING" />
                </div> */}
                                <div className="card-body">
                                    <div className="table-responsive table-card p-2">
                                        <table className="table align-middle" id="sightseeingTable">
                                            <thead className="bg-soft-success bg-gradient">
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Booking No</th>
                                                    <th>Destination</th>
                                                    <th>Travel Date</th>
                                                    <th>Traveller</th>
                                                    <th>Booking Status</th>
                                                    <th>Payment Status</th>
                                                    <th>Amount</th>
                                                    <th>Product URL</th> {/* Column Header */}
                                                    <th>Ticket</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pageLoading ? (
                                                    <tr>
                                                        <td colSpan="10" className="text-center"> {/* Increased colSpan to 10 */}
                                                            <p>Loading, Please wait...</p>
                                                        </td>
                                                    </tr>
                                                ) : lists.length > 0 ? (
                                                    lists.map((v, index) => (
                                                        <tr key={v.sightSeeingBookingId}>
                                                            <td>{index + 1}</td>
                                                            <td>{v.bookingNo}</td>
                                                            <td>{v.city}</td>
                                                            <td>{moment(v.travelDate).format("DD MMM YYYY")}</td>
                                                            <td>{v.travellerName}</td>
                                                            <td>
                                                                <span className={`badge bg-${v.bookingStatus === 'CONFIRMED' ? 'success' : 'warning'}`}>
                                                                    {v.bookingStatus}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span className={`badge bg-${v.paymentStatus === 'SUCCESS' ? 'success' : 'danger'}`}>
                                                                    {v.paymentStatus}
                                                                </span>
                                                            </td>
                                                            <td>{Math.round(v.customerPrice)} INR</td>

                                                            {/* PRODUCT URL BUTTON */}
                                                            <td>
                                                                {v.productURL ? (
                                                                    <a
                                                                        href={v.productURL}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="btn btn-sm btn-soft-secondary d-flex align-items-center gap-1"
                                                                    >
                                                                        <i className="ri-external-link-line"></i> VIEW PRODUCT
                                                                    </a>
                                                                ) : (
                                                                    <span className="text-muted">N/A</span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {v.ticketSrc ? (
                                                                    <a
                                                                        href={v.ticketSrc}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="btn btn-sm btn-soft-success"
                                                                    >
                                                                        <i className="ri-file-download-line"></i> TICKET
                                                                    </a>
                                                                ) : (
                                                                    <span className="text-muted">No Ticket</span>
                                                                )}
                                                            </td>

                                                            <td>
                                                                <div className="hstack gap-2">
                                                                    <Link
                                                                        to={`/sightseeing/booking/${v.sightSeeingBookingId}`}
                                                                        className="btn btn-sm btn-info"
                                                                    >
                                                                        VIEW
                                                                    </Link>
                                                                    <button
                                                                        onClick={() => handleEditClick(v)}
                                                                        className="btn btn-sm btn-primary"
                                                                    >
                                                                        EDIT
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="10" className="text-center">No bookings found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* EDIT MODAL */}
            {showModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header bg-light p-3">
                                <h5 className="modal-title">Update Booking: {selectedBooking?.bookingNo}</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <form onSubmit={handleUpdateSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Booking Status</label>
                                        <select
                                            className="form-select"
                                            name="bookingStatus"
                                            value={editForm.bookingStatus}
                                            onChange={handleInputChange}
                                        >
                                            <option value="PENDING">PENDING</option>
                                            <option value="CONFIRMED">CONFIRMED</option>
                                            <option value="CANCELLED">CANCELLED</option>
                                            <option value="FAILED">FAILED</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Payment Status</label>
                                        <select
                                            className="form-select"
                                            name="paymentStatus"
                                            value={editForm.paymentStatus}
                                            onChange={handleInputChange}
                                        >
                                            <option value="PENDING">PENDING</option>
                                            <option value="SUCCESS">SUCCESS</option>
                                            <option value="FAILED">FAILED</option>
                                            <option value="REFUNDED">REFUNDED</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Supplier Booking Status</label>
                                        <select
                                            className="form-select"
                                            name="supplierBookingStatus"
                                            value={editForm.supplierBookingStatus}
                                            onChange={handleInputChange}
                                        >
                                            <option value="PENDING">PENDING</option>
                                            <option value="CONFIRMED">CONFIRMED</option>
                                            <option value="CANCELLED">CANCELLED</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Upload Ticket (PDF/Image)</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={handleFileChange}
                                            accept=".pdf,image/*"
                                        />
                                        {selectedBooking?.ticketImageName && (
                                            <small className="text-muted">Current file: {selectedBooking.ticketImageName}</small>
                                        )}
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-light" onClick={() => setShowModal(false)}>Close</button>
                                    <button type="submit" className="btn btn-success" disabled={btnLoading}>
                                        {btnLoading ? "Updating..." : "Save Changes"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SightSeeingAdminUpdate;